var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{class:_vm.overlayCssClass},[_c('div',{class:_vm.loaderCssClass}),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }